import { render, staticRenderFns } from "./question-validations-field.vue?vue&type=template&id=0e20b2d0"
import script from "./question-validations-field.vue?vue&type=script&lang=js"
export * from "./question-validations-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports